<template>
    <div id="main_button">
        <router-link :to="{path: `${href_link}`}" :style="[{ color: is_not_done ? 'red' : ''}]">
            <br>
            <h3>{{text}}</h3>
            <br>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "MainButton",
        props:{
            text: String,
            href_link: String,
            is_not_done: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>